import { McpIcloudFormComponent } from './mcp-icloud-form.component';
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { McpProviderConnectionService } from './mcp-provider-connection.service';
@Component({
 selector:'app-mcp-provider-connection',standalone:true,imports:[CommonModule,McpIcloudFormComponent],
 template:`<main class="container py-5 text-center" aria-label="Mango account connection">
 <img src="assets/icons/appicon/ic_mangomirror_hdpi.png" width="64" alt="Mango Display">
 <h1 class="h4 mt-4">{{ connection.credentialSession ? 'Connect Apple iCloud Calendar' : connection.completed ? '🎉 Connection successful' : connection.finished ? 'Connection status' : 'Connecting your account' }}</h1>
 <div *ngIf="!connection.finished && !connection.credentialSession" class="connection-spinner my-4 mx-auto" aria-hidden="true"></div>
 <p *ngIf="!connection.finished && !connection.credentialSession">Please keep this tab open while we finish. This may take a moment.</p>
 <p role="status" aria-live="polite">{{ connection.status }}</p>
 <app-mcp-icloud-form *ngIf="connection.credentialSession"></app-mcp-icloud-form>
 <button *ngIf="connection.completed && !closeBlocked" type="button" class="btn btn-primary" (click)="closeTab()">Close tab</button>
 <p *ngIf="connection.finished && (!connection.completed || closeBlocked)" role="status" class="mt-3">Please close this tab to return to your chat.</p>
 </main>`,
 styles:[`.connection-spinner{width:36px;height:36px;border:4px solid #dceee4;border-top-color:#14b268;border-radius:50%;animation:mcp-provider-spin .8s linear infinite}@keyframes mcp-provider-spin{to{transform:rotate(360deg)}}@media(prefers-reduced-motion:reduce){.connection-spinner{animation:none}}`],
})
export class McpProviderConnectionComponent {
 closeBlocked=false;
 constructor(public connection:McpProviderConnectionService) {}
 closeTab(){
  try { window.close(); } catch { this.closeBlocked=true; return; }
  // If this page survives the close request, offer manual closing instead.
  window.setTimeout(()=>{this.closeBlocked=true;},500);
 }
}
